import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';
import { ConfirmAccountCreateDialogComponent } from '../confirm-account-create-dialog/confirm-account-create-dialog.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  submiting: boolean = false;
  form: FormGroup;
  planIndex: number = 0;
  isFree: boolean = false;

  constructor(
    private http: HttpService,
    private router: Router,
    private snackbar: MatSnackBar,
    private errorReport: ErrorReportService,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    fb: FormBuilder
  ) {

    this.form = fb.group({
      email: [null, [Validators.required, Validators.email]]
    });

    if (this.route.snapshot.queryParams.email) {
      this.form.patchValue({ email: this.route.snapshot.queryParams.email });
      this.submit();
    }

    this.route.queryParams.subscribe(
      query => {

        if (query.pi)
          this.planIndex = query.pi;

        if (query.free)
          this.isFree = true;

      }
    )

  }

  ngOnInit(): void {

    const subject = new Subject();
    subject.subscribe(
      ({ scope, trigger }: any) => {

        if (scope === 'auth:login')
          this.submiting = trigger === 'pre';

      }
    )
    this.http.setLoadingIndicator(subject);

  }

  submit() {

    if (!this.form.invalid) {
      const data = this.form.getRawValue();
      const options = {
        // responseType: 'json'
      }
      this.http.get('auth:login', data, options)
        .subscribe(
          (result: any) => {
            const login = result.data;
            // console.log(result)
            if (!login) {

              const options = {
                width: '500px',
                disabledClose: true,
              }
              this.dialog.open(ConfirmAccountCreateDialogComponent, options)
                .afterClosed()
                .subscribe(
                  result => {

                    if (result === 'CANDIDATE')
                      this.router.navigate(['/', 'register'], { queryParams: { email: data.email, pi: this.planIndex } })
                    else if (result === 'RECRUITER') {
                      let queryParams: any = {
                        email: data.email,
                        pi: this.planIndex
                      };

                      if (this.isFree)
                        queryParams.free = true;

                      this.router.navigate(
                        ['/', 'register', 'company'],
                        { queryParams }
                      )
                    }

                  }
                )
              this.snackbar.open('Email não encontrado, faça seu cadastro!', 'OK', { duration: 3000 });

              return;

            }

            if(login.approve == 1){

              if (parseInt(login.password))
                this.router.navigate(['/', 'auth', 'password'], { queryParams: { email: data.email } })
              else {

                if (login.account_type === 'company')
                  this.router.navigate(['/', 'register', 'company'], { queryParams: { email: data.email } })
                else this.router.navigate(['/', 'register'], { queryParams: { email: data.email } })

              }
            }else{
              this.snackbar.open('Acesso Negado: Estamos verificando seus dados. Em breve, entraremos em contato!', 'OK', { duration: 3000 });
            }

          },
          err => {
            console.error('ERR', err);
            this.errorReport.showMessage(err)
          }
        );

    }

  }

  confirmAccount() {

    const options = {
      width: '500px',
      disabledClose: true,
    }
    this.dialog.open(ConfirmAccountCreateDialogComponent, options)
      .afterClosed()
      .subscribe(
        result => {

          if (result === 'CANDIDATE')
            this.router.navigate(['/', 'register'], { queryParams: { pi: this.planIndex } })
          else if (result === 'RECRUITER') {
            let queryParams: any = {
              pi: this.planIndex
            };

            if (this.isFree)
              queryParams.free = true;

            this.router.navigate(
              ['/', 'register', 'company'],
              { queryParams }
            )
          }

        }
      )
  }

  openIntro() {
    this.snackbar.open('Use esse formulário de login para acessar sua conta de recrutador', 'OK', { duration: 4000 });
  }

}
